"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const SignInPage_container_1 = __importDefault(require("./SignInPage.container"));
exports.default = SignInPage_container_1.default;
//# sourceMappingURL=index.js.map